import { render, staticRenderFns } from "./perfect-company-info.vue?vue&type=template&id=97345316&scoped=true"
import script from "./perfect-company-info.vue?vue&type=script&lang=js"
export * from "./perfect-company-info.vue?vue&type=script&lang=js"
import style0 from "./perfect-company-info.vue?vue&type=style&index=0&id=97345316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97345316",
  null
  
)

export default component.exports